import { ActionsType, ProcessingAction } from 'types/rest/assetCatalogTypes';
import axios from 'axios/axios-base';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import i18n from 'i18n';
import store from 'store/configureStore';
import _ from 'lodash';
import { transformConditionsToBase64 } from '../../../../../utils/transactionUtils';

const messageDict = {
  WEBHOOK: {
    post: 'transactions:processingActions.modal.successWebhook',
    patch: 'transactions:processingActions.modal.successEditWebhook',
  },
  STATE_UPDATE: {
    post: 'transactions:processingActions.modal.successStateUpdate',
    patch: 'transactions:processingActions.modal.successEditStateUpdate',
  },
  HTTP_CALL: {
    post: 'transactions:processingActions.modal.httpCallModal.success',
    patch: 'transactions:processingActions.modal.httpCallModal.successEdit',
  },
};

export const saveProcessingAction = async (processingAction: ProcessingAction, type: ActionsType) => {
  const url = `workspaces/{workspaceId}/transactions/${processingAction.transactionId}/actions`;
  let message;
  const actions = {
    id: processingAction.id,
    name: processingAction.name,
    actionType: processingAction.actionType,
    definition: processingAction.definition,
    transactionId: processingAction.transactionId,
    assets: processingAction.assets,
    configKeyAssets: processingAction.configKeyAssets,
    conditions: transformConditionsToBase64(processingAction.conditions, 'base64encode'),
  };
  if (_.isNil(processingAction.id)) {
    await axios.post(url, actions);
    message = messageDict[type].post;
  } else {
    await axios.patch(`${url}/${processingAction.id}`, actions);
    message = messageDict[type].patch;
  }
  store.dispatch(showToastNotification(ToastType.Success, `${i18n.t(message)} ${processingAction.name}`));
};

export const getProcessingActionType = (actionType: ActionsType) => {
  switch (actionType) {
    case 'WEBHOOK':
      return 'WebHook';
    case 'STATE_UPDATE':
      return 'StateUpdate';
    case 'HTTP_CALL':
      return 'HTTP Call';
  }
  return '-';
};
